export const QueryKeys = {
  AuditEvents: 'list/auditEvents',
};
